<template>
  <div class="content">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
          <div style="float: right; padding: 3px 0">
            <el-radio-group v-model="dateRadio"  @change="initData">
              <el-radio-button label="日">日</el-radio-button>
              <el-radio-button label="月">月</el-radio-button>
              <el-radio-button label="年">年</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div id="main" style="width:100%;height:750px"></div>
    </el-card>
  </div>
</template>
<script>
import * as echarts from "echarts"
import resize from '../../dashboard/mixins/resize'
import { payAccountList } from "@/api/api.js";
export default {
  mixins: [resize],
  data() {
    return{
      dateRadio:'日',
      chartData:{},
    }
  },
  
  methods: {
    initData(type = '日'){
      payAccountList({type}).then(res=>{
        this.chartData = res.data.data
        this.setOptionsBar()
      })
    },
    setOptions() {
      let chart = echarts.init(document.getElementById('main'))
      let series = []
      this.chartData.accountItems.forEach(element => {
        let item = {
            name: element.name,
            type: 'line',
            stack: 'total',
            data: element.amountList
          }
         series.push(item) 
      });
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.timeList
        },
        yAxis: {
          type: 'value'
        },
        series: series
      });
    },
    setOptionsBar() {
      let chart = echarts.init(document.getElementById('main'))
      let series = []
      this.chartData.accountItems.forEach(element => {
        let item = {
            name: element.name,
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            barMinHeight: 10,
            data: element.amountList
          }
         series.push(item) 
      });
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.timeList
        },
        yAxis: {
          type: 'value'
        },
        series: series
      });
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    
  },
};
</script>

<style scoped lang="less">

</style>


